export default "__VITE_ASSET__BnoXZ9ph__"